export type UserRole = 'system_admin' | 'dept_manager' | 'employee' | 'auditor' | 'read_only';

export type PermissionKey =
  | 'app.view'
  | 'admin.view'
  | 'admin.departments.create'
  | 'admin.departments.edit'
  | 'admin.departments.delete'
  | 'admin.users.manage'
  | 'admin.system.settings'
  | 'dept.view'
  | 'dept.customize'
  | 'dept.drive.connect'
  | 'drive.manage'
  | 'documents.upload'
  | 'documents.view'
  | 'documents.edit'
  | 'documents.delete'
  | 'documents.replace'
  | 'documents.disable_qr'
  | 'documents.download'
  | 'audit.view'
  | 'archive_cycles.view'
  | 'archive_cycles.create'
  | 'archive_cycles.close'
  | 'archive_cycles.reset'
  | 'archive_cycles.restore'
  | 'archive_cycles.export'
  | 'archive_cycles.hard_delete'
  | 'archive_cycles.approve'
  | 'documents.qr_overlay.view'
  | 'documents.qr_overlay.create'
  | 'documents.qr_overlay.update'
  | 'documents.qr_overlay.print'
  | 'documents.qr_overlay.download'
  | 'documents.qr_overlay.manage_templates'
  | 'documents.qr_overlay.approve'
  | 'documents.qr_overlay.print_confidential';

export const ROLE_PERMISSIONS: Record<UserRole, PermissionKey[]> = {
  system_admin: [
    'app.view', 'admin.view',
    'admin.departments.create', 'admin.departments.edit', 'admin.departments.delete',
    'admin.users.manage', 'admin.system.settings',
    'dept.view', 'dept.customize', 'dept.drive.connect', 'drive.manage',
    'documents.upload', 'documents.view', 'documents.edit',
    'documents.delete', 'documents.replace', 'documents.disable_qr',
    'documents.download', 'audit.view',
    'archive_cycles.view', 'archive_cycles.create', 'archive_cycles.close',
    'archive_cycles.reset', 'archive_cycles.restore', 'archive_cycles.export',
    'archive_cycles.hard_delete', 'archive_cycles.approve',
    'documents.qr_overlay.view', 'documents.qr_overlay.create', 'documents.qr_overlay.update',
    'documents.qr_overlay.print', 'documents.qr_overlay.download', 'documents.qr_overlay.manage_templates',
    'documents.qr_overlay.approve', 'documents.qr_overlay.print_confidential',
  ],
  dept_manager: [
    'app.view', 'dept.view', 'dept.customize', 'dept.drive.connect', 'drive.manage',
    'documents.upload', 'documents.view', 'documents.edit',
    'documents.replace', 'documents.disable_qr', 'documents.download',
    'audit.view',
    'archive_cycles.view', 'archive_cycles.create', 'archive_cycles.close',
    'archive_cycles.reset', 'archive_cycles.restore', 'archive_cycles.export',
    'documents.qr_overlay.view', 'documents.qr_overlay.create', 'documents.qr_overlay.update',
    'documents.qr_overlay.print', 'documents.qr_overlay.download', 'documents.qr_overlay.manage_templates',
    'documents.qr_overlay.print_confidential',
  ],
  employee: [
    'app.view', 'dept.view',
    'documents.upload', 'documents.view', 'documents.download',
    'archive_cycles.view',
    'documents.qr_overlay.view', 'documents.qr_overlay.create',
    'documents.qr_overlay.print', 'documents.qr_overlay.download',
  ],
  auditor: [
    'app.view', 'dept.view',
    'documents.view', 'documents.download', 'audit.view',
    'archive_cycles.view',
    'documents.qr_overlay.view',
  ],
  read_only: [
    'app.view', 'dept.view',
    'documents.view', 'documents.download',
    'archive_cycles.view',
    'documents.qr_overlay.view',
  ],
};

export function hasPermission(role: UserRole, permission: PermissionKey): boolean {
  return ROLE_PERMISSIONS[role]?.includes(permission) ?? false;
}
